import { Avatar, Badge } from "antd";
import React, { useEffect } from "react";
import NotificationsOffOutlinedIcon from "@mui/icons-material/NotificationsOffOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { IconButton } from "@mui/material";
import NotificationModal from "./NotificationModal";
import { useRecoilState, useRecoilValue } from "recoil";
import { notificationPermission } from "../../../components/recoil/notificationPermissioRecoil";
import {
  notificationModal,
  notifications,
  refreshNotifications,
} from "../../../components/recoil/notificationsRecoil";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import { useGetOrgIdentifier } from "../../generic/hooks/useGetOrgIdentifier";
import MemoryType from "../../../service/memory/enum/MemoryType";
import apiService from "../../../service/apiservice/apiService";
import { useLocation } from "react-router";

const Notification = () => {
  const organizationIdentifier = useGetOrgIdentifier();
  const permission = useRecoilValue(notificationPermission);
  const user = useReadMemory(MemoryType.USER);
  const [notificationList, setNotificationList] = useRecoilState(notifications);
  const location = useLocation();
  const [modal, setModal] = useRecoilState(notificationModal);
  const refresh = useRecoilValue(refreshNotifications);

  useEffect(() => {
    const getNotifications = async () => {
      const endpoint = "niramayafoundation/api/v1/communication/message";
      const params = {
        organizationIdentifier,
        recipient: user?.userIdentifier,
        keywords: "notification",
        unread: true,
      };
      const response = await apiService.get(endpoint, params);
      if (Array.isArray(response)) {
        setNotificationList(response);
      }
    };

    getNotifications();
  }, [
    organizationIdentifier,
    user?.userIdentifier,
    refresh,
    setNotificationList,
    location.pathname,
  ]);

  return (
    <>
      <IconButton
        style={{ padding: 4 }}
        size="large"
        color="inherit"
        onClick={() => setModal(true)}
      >
        <Badge count={notificationList?.length}>
          <Avatar
            style={{
              backgroundColor: "var(--main-theme-color)",
            }}
            icon={
              permission === "granted" ? (
                <NotificationsNoneOutlinedIcon style={{ marginBottom: 4 }} />
              ) : (
                <NotificationsOffOutlinedIcon style={{ marginBottom: 4 }} />
              )
            }
          />
        </Badge>
      </IconButton>

      {notificationModal && (
        <NotificationModal modal={modal} setModal={setModal} />
      )}
    </>
  );
};

export default Notification;
